// casting constructor function as it will be resolved at runtime anyway
export const isEmpty = (obj: Record<string | number | symbol, unknown> | unknown[]) =>
    [Object, Array].includes((obj || {}).constructor as ObjectConstructor | ArrayConstructor) && !Object.entries(obj || {}).length;
